import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type {
  CreateIngredientRequest,
  IngredientDto,
  UpdateIngredientRequest,
} from './types';

const QK_LIST = ['ingredients'] as const;

export function useIngredients() {
  return useQuery({
    queryKey: QK_LIST,
    queryFn: async () => (await apiClient.get<IngredientDto[]>('/api/ingredients')).data,
  });
}

export function useCreateIngredient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreateIngredientRequest) =>
      (await apiClient.post<IngredientDto>('/api/ingredients', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useUpdateIngredient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdateIngredientRequest }) =>
      (await apiClient.put<IngredientDto>(`/api/ingredients/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useDeleteIngredient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/ingredients/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}
